import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=3383e8a7&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorMessage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ErrorMessage.vue?vue&type=style&index=0&id=3383e8a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3383e8a7",
  null
  
)

export default component.exports